const DOMAIN = process.env.REACT_APP_DOMAIN || "https://localhost:44331/api";
const STRIPEPAYMENT_DOMAIN = process.env.REACT_APP_STRIPEPAYMENT_DOMAIN || "http://localhost:21295";

export const API_URLS = {
  OPTION_CALCULATOR: `${DOMAIN}/OptionCalculator`,
  GetOptionPackages: `${DOMAIN}/OptionCombo/Packages`,
  DeleteOptionPackage: `${DOMAIN}/OptionCombo`,
  GetUserPermissions: `${DOMAIN}/UserPermission`,
  SAVEMESSAGE: `${DOMAIN}/CustomerMessage`,
  STRIPE_CREATE_CHECKOUT_SESSION: `${STRIPEPAYMENT_DOMAIN}/create-checkout-session`,
  STRIPE_SESSION_STATUS: `${STRIPEPAYMENT_DOMAIN}/session-status`,
};

export const stripeConfig = {
    BasicPlan: process.env.REACT_APP_STRIPE_PRICE_BASIC || "",
    PremiumPlan: process.env.REACT_APP_STRIPE_PRICE_PREMIUM || "",
    Stripe_Key: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ""
};


